// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dv6t","title":"styles_title__2ZHPJ"};